import { render, staticRenderFns } from "./GameProjectIcon.vue?vue&type=template&id=66d924fc"
import script from "./GameProjectIcon.vue?vue&type=script&lang=js"
export * from "./GameProjectIcon.vue?vue&type=script&lang=js"
import style0 from "./GameProjectIcon.vue?vue&type=style&index=0&id=66d924fc&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports